<template>
	<div id="app">

		<navbar :to="'/cinema'"></navbar>

		<div class="movie-top">
			<div class="containner flex item-end py-20" v-if="$store.getters.cinemadetail">
				<img :src="'http://124.222.209.62/atstudy-cateye/imgs/cma_img/'+ $store.getters.cinemadetail.cinema.cmaImgs" class="movie-img"/>
				<div class="white text-left ml-40">
					<div class="movie-name weight">{{$store.getters.cinemadetail.cinema.cmaName}}</div>
					<div class="movie-title bold">{{$store.getters.cinemadetail.cinema.cmaAddress}}</div>
					<div class="movie-title">{{$store.getters.cinemadetail.cinema.cmaPhone}}</div>
					<div class="text-md mt-5">
						<div class="flex mt-5 ser-con" v-for="(service,index) of $store.getters.cinemadetail.cmaServices"
								:key="'service-'+ index">
							<div class="mr-10 ser-title">{{service.ser_name}}</div>
							<div>{{service.ser_desc}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="$store.getters.cinemadetail">
			<div class="containner" v-if="$store.getters.cinemadetail.films.length>0">

				<div class="flex justify-between item-center">
					<div class="gray hand weight text-48 hover-red" @click="arrow_left_clicked">&lt;</div>
					<div style="width: 1100px; overflow: hidden;" ref="film_list">
						<div class="flex  item-center mt-30" :style="{'width':$store.getters.cinemadetail.films.length*200+40+'px'}">
							<div v-for="film of $store.getters.cinemadetail.films"
							:key="film.filmId" 
							class="film mx-10 my-10 rounded box-shadow hand hover-box-shadow-blue"
							:class="{'active':selected_film.filmId==film.filmId}"
							@click="film_clicked(film)">
								<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>					
							</div>
						</div>
					</div>
					<div class="gray hand weight text-48 hover-red" @click="arrow_right_clicked">&gt;</div>
				</div>

				<div class="flex item-end text-left mt-20 ml-40">
					<div class="text-xl dark bold">{{selected_film.filmName}}</div>
					<div v-if="selected_film.filmPraise">
						<div class="ml-40 red text-xl weight">{{selected_film.filmPraise}}</div>
					</div>
					<div v-else class="ml-40">暂无</div>
					
				</div>
				<div class="flex item-end text-left text-md  my-10">
					<div class="gray ml-40">时长：</div>
					<div class="dark ml-5">{{selected_film.filmTimelong}}</div>
					<div class="gray ml-40">类型：</div>
					<div class="dark ml-5">{{selected_film.filmCateKeyword}}</div>
					<div class="gray ml-40">主演：</div>
					
					<div class="dark ml-5" v-for="actor of actors"
					:key="'actor-'+actor.act_id">{{actor.act_name}}</div>
					
					
				</div>
				
				<div v-if="this.selected_watch.length > 0">
					<div class="mt-40 flex item-center text-md">
						<div class="gray px-10 py-5">观影时间：</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 active">
							<span class="ml-5">{{this.selected_watch[0].wdDate}}</span>
						</div>
					</div>
					<div class="mt-30 text-md">
						
						<div class="round my-20 px-20 py-20 flex item-center justify-between rounded box-shadow hover-box-shadow-blue"
							v-for="watch of this.selected_watch" :key="watch.wtId">
							<div class="w-20">
								<div class="text-xl weight dark">{{watch.wtBegintime}}</div>
								<div class="mt-10 text-sm gray">{{watch.wtEndtime}} 散场</div>
							</div>
							<div class="w-20 text-lg dark">{{watch.wtVersion}}</div>
							<div class="w-25">
								<div class="text-lg dark">{{watch.wtHalls}}</div>
							</div>
							<div class="w-15 red">
								<span class="text-sm mr-5">￥</span>
								<span class="text-xl weight">{{watch.wtCost}}</span>
							</div>
							<div class="20">
								<button class="btn-round-buy hand" @click="watch_clicked(watch.wtId)">选座购票</button>
							</div>
						</div>
					</div>
				</div>	
				
				<div class="my-40" v-else>
					<h1>暂无场次信息</h1>
				</div>
			</div>
		</div>
		<div class="containner my-40" v-else>
			<h1>暂无影片资源</h1>
		</div>
		
		<foot />

	</div>
</template>

<script>
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	
	export default {
		data () {
			return {
				selected_film: {},
				actors: [],
				selected_watch: []
			} 
		},
		components:{
			navbar,
			foot
		},
		methods: {
			loads () {
				
				this.$store.dispatch('actCinemaDetailLoad',{payload:this.$route.params.id})
				.then(res => {
					
					if(this.$store.getters.cinemadetail){
						if(this.$store.getters.cinemadetail.films.length>0){
						this.selected_film = this.$store.getters.cinemadetail.films[0]
						
						let count = 0
						
						for(let actor of this.$store.getters.cinemadetail.actors[this.selected_film.filmId.toString()][1].content){
							
							if(count>5)
								break
							
							this.actors.push(actor)
							count++
						}
						
					}
					console.log(this.actors)
					}
					
				})
			},
			film_clicked (film) {
				this.selected_film = film
				this.selected_watch = this.$store.getters.cinemadetail.watchTimes[film.filmId.toString()]

			},
			watch_clicked (watchId) {
				this.$router.push({
					path: '/watch',
					query: {
						filmId: this.selected_film.filmId,
						watchId: watchId
					}
				})
			},
			// 点击了影片列表左箭头
			arrow_left_clicked(){
				this.$refs.film_list.scrollLeft = this.$refs.film_list.scrollLeft - 200;
			},
			// 点击了影片列表右箭头
			arrow_right_clicked(){
				this.$refs.film_list.scrollLeft = this.$refs.film_list.scrollLeft + 200;
			}
		},
		mounted () {
			this.loads()
		}
	}
	
</script>

<style>
	.ser-con div{height: 30px; line-height: 30px; font-size: 12px;}
	.ser-title{border: 1px solid white; border-radius: 3px; padding-left: 10px;padding-right: 10px; }
</style>
